module.exports = __webpack_public_path__ + "fd48c0519561b3004eb38aa323aacf7e.svg";